module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"components":{"base":{"search_bar":{"query_too_long_hint":"Geben Sie weniger Zeichen ein, um Suchergebnisse anzuzeigen."}}}}}}')
  delete Component.options._Ctor
}
